import type { ObjectLookup } from 'src/util';

/**
	 * An extension of Error, allows for adding additional properties
	 * to the error object and a flag denoting whether or not to track
	 * the error
	 */
export class CError extends Error {
	name: string;
	message: string;
	// An error is not logged when `log` is exactly false
	log?: boolean;
	stack?: string;
	additionalProperties?: ObjectLookup<any>;

	constructor(message: string, log: boolean = true, name?: string, stack?: string, additionalProperties?: ObjectLookup<any>) {
		super(message);

		this.message = message;
		this.log = log;
		this.name = name || this.name;
		this.stack = stack || this.stack;
		this.additionalProperties = additionalProperties;
	}
}

/**
	 * A version of CError that by default, doesn't log the error
	 * to the server. Used for errors consumed by the end-user.
	 */
export class FriendlyError extends CError {
	constructor(message: string, name?: string) {
		super(message, false, name);
	}
}